(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-breakdown"] && !Shopify.designMode) return;
  try {
    
  if (!window.reposBreakdownRailInitialized) {
    window.reposBreakdownRailInitialized = true;

    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-breakdown-arrow]');

      if (!button) return;

      const section = button.closest('.breakdown');
      const track = section?.querySelector('[data-breakdown-track]');
      const card = track?.querySelector('.breakdown__col');

      if (!track || !card) return;

      const direction = button.dataset.breakdownArrow === 'next' ? 1 : -1;
      const gap = Number.parseFloat(window.getComputedStyle(track).columnGap || window.getComputedStyle(track).gap) || 24;
      const distance = card.getBoundingClientRect().width + gap;

      track.scrollBy({
        left: distance * direction,
        behavior: 'smooth',
      });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["social-proof-strip"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('.proof:not([data-proof-countup-bound])');
    if (!sections.length) return;

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const formatCount = (value, format) => {
      if (format === 'decimal') return value.toFixed(1);
      return Math.round(value).toLocaleString('en-US');
    };

    const animateCount = (element) => {
      if (element.dataset.proofCounted === 'true') return;

      const target = Number(element.dataset.countTo);
      if (!Number.isFinite(target)) return;
      const currentText = element.textContent.replace(/,/g, '');
      const start = Number(currentText);
      const initial = Number.isFinite(start) ? start : 0;

      element.dataset.proofCounted = 'true';
      const format = element.dataset.countFormat;

      if (prefersReducedMotion) {
        element.textContent = formatCount(target, format);
        return;
      }

      const duration = format === 'decimal' ? 650 : 950;
      const startedAt = performance.now();
      const easeOut = (progress) => 1 - Math.pow(1 - progress, 3);

      const tick = (now) => {
        const progress = Math.min((now - startedAt) / duration, 1);
        element.textContent = formatCount(initial + (target - initial) * easeOut(progress), format);

        if (progress < 1) {
          requestAnimationFrame(tick);
        } else {
          element.textContent = formatCount(target, format);
        }
      };

      requestAnimationFrame(tick);
    };

    const animateSection = (section) => {
      section.querySelectorAll('.proof__countup').forEach(animateCount);
    };

    sections.forEach((section) => {
      section.dataset.proofCountupBound = 'true';

      const track = section.querySelector('[data-proof-track]');
      const arrows = section.querySelectorAll('[data-proof-arrow]');
      const updateArrows = () => {
        if (!track || !arrows.length) return;
        const maxScroll = track.scrollWidth - track.clientWidth;
        const atStart = track.scrollLeft <= 2;
        const atEnd = track.scrollLeft >= maxScroll - 2;

        arrows.forEach((arrow) => {
          const direction = arrow.dataset.proofArrow;
          arrow.disabled = direction === 'previous' ? atStart : atEnd;
        });
      };

      arrows.forEach((arrow) => {
        arrow.addEventListener('click', () => {
          if (!track) return;
          const card = track.querySelector('.proof__card');
          const gap = Number.parseFloat(window.getComputedStyle(track).columnGap) || 0;
          const step = card ? card.getBoundingClientRect().width + gap : track.clientWidth * 0.82;
          const direction = arrow.dataset.proofArrow === 'previous' ? -1 : 1;

          track.scrollBy({
            left: step * direction,
            behavior: prefersReducedMotion ? 'auto' : 'smooth'
          });
        });
      });

      if (track) {
        track.addEventListener('scroll', updateArrows, { passive: true });
        window.addEventListener('resize', updateArrows);
        updateArrows();
      }

      if (!('IntersectionObserver' in window)) {
        animateSection(section);
        return;
      }

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            animateSection(entry.target);
            observer.unobserve(entry.target);
          });
        },
        { threshold: 0.35 }
      );

      observer.observe(section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trustpilot-repos"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('.trustpilot-repos:not([data-trustpilot-bound])');
    sections.forEach((section) => {
      section.dataset.trustpilotBound = 'true';
      const rail = section.querySelector('[data-trustpilot-rail]');
      if (!rail) return;

      const scrollRail = (direction) => {
        const card = rail.querySelector('.trustpilot-repos__card');
        const gap = 24;
        const amount = card ? card.getBoundingClientRect().width + gap : rail.clientWidth * 0.8;
        rail.scrollBy({ left: direction * amount, behavior: 'smooth' });
      };

      section.querySelector('[data-trustpilot-prev]')?.addEventListener('click', () => scrollRail(-1));
      section.querySelector('[data-trustpilot-next]')?.addEventListener('click', () => scrollRail(1));
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
